"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Input = _interopRequireDefault(require("../../../Input"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _Tooltip = _interopRequireDefault(require("../../../Tooltip"));
var _iconsReact = require("../../../../icons-react");
var _excluded = ["label", "error"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ERRORS = {
  EMPTY: 'Поле не должно быть пустым.',
  PATTERN: 'Неправильный формат'
};
var EditableField = /*#__PURE__*/function (_React$PureComponent) {
  function EditableField(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, EditableField);
    _this = _callSuper(this, EditableField, [props]);
    var value = _this.props.value;
    _this.state = {
      error: null,
      isEditing: false,
      prevValue: value
    };
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
    _this.handleOpen = _this.handleOpen.bind(_this);
    _this.handleReset = _this.handleReset.bind(_this);
    _this.handleSave = _this.handleSave.bind(_this);
    _this.inputRenderer = _this.inputRenderer.bind(_this);
    _this.labelRenderer = _this.labelRenderer.bind(_this);
    _this.toggleEditing = _this.toggleEditing.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(EditableField, _React$PureComponent);
  return (0, _createClass2["default"])(EditableField, [{
    key: "handleFocus",
    value: function handleFocus() {
      var onFocus = this.props.onFocus;
      this.setState({
        error: null
      }, onFocus);
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(_ref) {
      var key = _ref.key;
      var error = this.state.error;
      if (error) {
        this.setState({
          error: null
        });
      }
      if (key === 'Escape') {
        this.handleReset();
      }
      if (key === 'Enter') {
        this.handleSave();
      }
    }
  }, {
    key: "handleSave",
    value: function handleSave() {
      var _this$props = this.props,
        name = _this$props.name,
        onSave = _this$props.onSave,
        preventClose = _this$props.preventClose,
        required = _this$props.required,
        validation = _this$props.validation,
        value = _this$props.value;
      if (required && !value) {
        this.setState({
          error: ERRORS.EMPTY
        });
        return;
      }
      if (validation) {
        var pattern = (0, _get2["default"])(validation, 'pattern') || null;
        var patternError = (0, _get2["default"])(validation, 'error') || ERRORS.PATTERN;
        if (pattern) {
          var regex = new RegExp(pattern);
          var isValid = regex.test(value);
          if (!isValid) {
            this.setState({
              error: patternError
            });
            return;
          }
        }
      }
      this.setState({
        isEditing: preventClose,
        prevValue: value
      }, onSave({
        name: name,
        value: value
      }));
    }
  }, {
    key: "handleOpen",
    value: function handleOpen() {
      var _this$props2 = this.props,
        value = _this$props2.value,
        onOpen = _this$props2.onOpen;
      onOpen({
        value: value
      });
    }
  }, {
    key: "handleReset",
    value: function handleReset() {
      var _this$props3 = this.props,
        name = _this$props3.name,
        onReset = _this$props3.onReset;
      var value = this.state.prevValue;
      this.setState({
        error: null,
        isEditing: false
      }, onReset({
        name: name,
        value: value
      }));
    }
  }, {
    key: "labelRenderer",
    value: function labelRenderer() {
      var _this$props4 = this.props,
        label = _this$props4.label,
        readOnly = _this$props4.readOnly;
      var isEditing = this.state.isEditing;
      return /*#__PURE__*/_react["default"].createElement(StyledLabelWrap, null, /*#__PURE__*/_react["default"].createElement(StyledLabel, null, label), !isEditing && !readOnly && /*#__PURE__*/_react["default"].createElement(StyledEditButton, {
        onClick: this.toggleEditing
      }, /*#__PURE__*/_react["default"].createElement(_iconsReact.EditField, null)));
    }
  }, {
    key: "inputRenderer",
    value: function inputRenderer() {
      var _this$state = this.state,
        prevValue = _this$state.prevValue,
        isEditing = _this$state.isEditing;
      var _this$props5 = this.props,
        children = _this$props5.children,
        label = _this$props5.label,
        name = _this$props5.name,
        onChange = _this$props5.onChange,
        placeholder = _this$props5.placeholder,
        readOnly = _this$props5.readOnly,
        value = _this$props5.value,
        required = _this$props5.required,
        disabled = _this$props5.disabled;
      var isSavable = (!required || required && !!value) && value !== prevValue;
      return isEditing ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledInput, {
        autoFocus: true,
        value: value,
        name: name,
        placeholder: placeholder,
        onFocus: this.handleFocus,
        onKeyDown: this.handleKeyPress,
        onChange: onChange
      }), isSavable && /*#__PURE__*/_react["default"].createElement(StyledApplyButton, {
        onClick: this.handleSave
      }, /*#__PURE__*/_react["default"].createElement(_iconsReact.FieldApply, null)), /*#__PURE__*/_react["default"].createElement(StyledCloseButton, {
        onClick: this.handleReset
      }, /*#__PURE__*/_react["default"].createElement(_iconsReact.FieldClose, null))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children || (value ? /*#__PURE__*/_react["default"].createElement(StyledValue, {
        disabled: disabled,
        onClick: this.handleOpen
      }, value) : /*#__PURE__*/_react["default"].createElement(StyledPlaceholder, null, placeholder)), !label && !readOnly && /*#__PURE__*/_react["default"].createElement(StyledEditButton, {
        onClick: this.toggleEditing
      }, /*#__PURE__*/_react["default"].createElement(_iconsReact.EditField, null)));
    }
  }, {
    key: "toggleEditing",
    value: function toggleEditing() {
      this.setState(function (prevState) {
        return {
          isEditing: !prevState.isEditing
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
        label = _this$props6.label,
        externalError = _this$props6.error,
        props = (0, _objectWithoutProperties2["default"])(_this$props6, _excluded);
      var localError = this.state.error;
      var error = externalError || localError;

      // Fixes test warnings.
      delete props.onOpen;
      delete props.onSave;
      delete props.onFocus;
      return /*#__PURE__*/_react["default"].createElement(StyledEditableField, props, label && this.labelRenderer(), /*#__PURE__*/_react["default"].createElement(StyledInputWrap, null, error && /*#__PURE__*/_react["default"].createElement(StyledTooltipWrap, null, /*#__PURE__*/_react["default"].createElement(StyledTooltip, {
        shown: true,
        content: error
      })), this.inputRenderer()));
    }
  }]);
}(_react["default"].PureComponent);
EditableField.propTypes = {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  error: _propTypes["default"].string,
  label: _propTypes["default"].string,
  name: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onOpen: _propTypes["default"].func,
  onReset: _propTypes["default"].func,
  onSave: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  preventClose: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  required: _propTypes["default"].bool,
  validation: _propTypes["default"].shape({
    error: _propTypes["default"].string,
    pattern: _propTypes["default"].string
  }),
  value: _propTypes["default"].string
};
EditableField.defaultProps = {
  children: null,
  className: '',
  error: null,
  label: null,
  name: null,
  onChange: Function.prototype,
  onFocus: Function.prototype,
  onOpen: Function.prototype,
  onReset: Function.prototype,
  onSave: Function.prototype,
  placeholder: '',
  preventClose: false,
  readOnly: false,
  required: false,
  validation: null,
  value: ''
};
var StyledFlex = _styledComponents["default"].div.withConfig({
  displayName: "EditableField__StyledFlex",
  componentId: "sc-1hku7yb-0"
})(["display:flex;align-items:center;"]);
var StyledLabelWrap = (0, _styledComponents["default"])(StyledFlex).withConfig({
  displayName: "EditableField__StyledLabelWrap",
  componentId: "sc-1hku7yb-1"
})(["width:100px;min-width:100px;"]);
var StyledInputWrap = (0, _styledComponents["default"])(StyledFlex).withConfig({
  displayName: "EditableField__StyledInputWrap",
  componentId: "sc-1hku7yb-2"
})(["align-items:center;display:flex;flex:1;position:relative;"]);
var StyledTooltip = (0, _styledComponents["default"])(_Tooltip["default"]).withConfig({
  displayName: "EditableField__StyledTooltip",
  componentId: "sc-1hku7yb-3"
})(["border:none;width:220px;font-size:14px;text-align:center;margin-bottom:-15px;background-color:#f8e71c;margin-left:-110px;:before{border-top-color:#f8e71c;}:after{border-top-color:#f8e71c;}"]);
var StyledButtonReset = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "EditableField__StyledButtonReset",
  componentId: "sc-1hku7yb-4"
})(["padding:0;width:auto;border:none;background:none;line-height:normal;"]);
var StyledLabel = _styledComponents["default"].div.withConfig({
  displayName: "EditableField__StyledLabel",
  componentId: "sc-1hku7yb-5"
})(["font-size:14px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;max-width:calc(100% - 25px);"]);
var StyledPlaceholder = _styledComponents["default"].div.withConfig({
  displayName: "EditableField__StyledPlaceholder",
  componentId: "sc-1hku7yb-6"
})(["color:#919499;font-size:14px;cursor:default;display:inline-block;"]);
var StyledEditButton = (0, _styledComponents["default"])(StyledButtonReset).withConfig({
  displayName: "EditableField__StyledEditButton",
  componentId: "sc-1hku7yb-7"
})(["width:16px;height:15px;margin-top:2px;margin-left:6px;opacity:0;&:hover svg path{fill:#007aff;}"]);
var StyledTooltipWrap = _styledComponents["default"].div.withConfig({
  displayName: "EditableField__StyledTooltipWrap",
  componentId: "sc-1hku7yb-8"
})(["left:0;right:0;margin-left:auto;margin-right:auto;position:absolute;"]);
var StyledValue = (0, _styledComponents["default"])(StyledButtonReset).withConfig({
  displayName: "EditableField__StyledValue",
  componentId: "sc-1hku7yb-9"
})(["height:auto;color:#007aff;font-size:14px;overflow:hidden;text-align:left;white-space:nowrap;text-overflow:ellipsis;text-decoration:underline;", ""], function (props) {
  return props.disabled && "\n    color: #c2c5cc;\n  ";
});
var StyledInput = (0, _styledComponents["default"])(_Input["default"]).withConfig({
  displayName: "EditableField__StyledInput",
  componentId: "sc-1hku7yb-10"
})(["background:none;border:none;flex:1;font-family:inherit;font-size:14px;font-weight:normal;padding:0;"]);
var StyledApplyButton = (0, _styledComponents["default"])(StyledButtonReset).withConfig({
  displayName: "EditableField__StyledApplyButton",
  componentId: "sc-1hku7yb-11"
})(["width:15px;height:12px;margin-left:10px;"]);
var StyledCloseButton = (0, _styledComponents["default"])(StyledButtonReset).withConfig({
  displayName: "EditableField__StyledCloseButton",
  componentId: "sc-1hku7yb-12"
})(["width:12px;height:12px;margin-left:10px;"]);
var StyledEditableField = (0, _styledComponents["default"])(StyledFlex).withConfig({
  displayName: "EditableField__StyledEditableField",
  componentId: "sc-1hku7yb-13"
})(["height:36px;:hover{", "{opacity:1;}}"], StyledEditButton);
EditableField.StyledInput = StyledInput;
EditableField.StyledPlaceholder = StyledPlaceholder;
EditableField.StyledValue = StyledValue;
var _default = exports["default"] = EditableField;